import { render } from "./CreateInventoryUid.vue?vue&type=template&id=6dfe0f2e"
import script from "./CreateInventoryUid.vue?vue&type=script&lang=js"
export * from "./CreateInventoryUid.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./CreateInventoryUid.vue?vue&type=style&index=1&id=6dfe0f2e&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__